var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { motion } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from 'moment';
import ImageSchema from './Shared/ImageSchema';
export default function StripStoryCardContainer(props) {
    var fields = props.fields;
    var pathname = useLocation().pathname;
    var _a = useState(fields.amount || 0), amount = _a[0], setAmount = _a[1];
    var _b = useState(fields.dataSourceItems.length || 0), storyLength = _b[0], setStoryLength = _b[1];
    var navigate = useNavigate();
    //useEffect(() => {
    //    window.scrollTo(0, 0);
    //}, [pathname]);
    var cardVariants = {
        offscreen: {
            opacity: 0
        },
        onscreen: {
            opacity: 1
        }
    };
    function incrementAmount() {
        var newValue = amount + fields.amount;
        setAmount(newValue);
    }
    return (React.createElement("div", __assign({ className: "strip sky23-story-cards container-fluid" }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 g-4" }, fields && fields.dataSourceItems && fields.dataSourceItems.length > 0 && fields.dataSourceItems.map(function (item, j) {
            var formatDate = item.fields.date ? moment(item.fields.date).format('D MMM YYYY') : "";
            return (React.createElement(React.Fragment, { key: j }, amount > j &&
                React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-20%" }, className: "col" },
                    React.createElement("div", { className: "card-with-image bg-beige px-0 border-radius d-flex flex-column", itemScope: true, itemType: "https://schema.org/Article", tabIndex: 0, onClick: function () { return navigate(item.url ? item.url : "#"); }, role: "link" },
                        item.fields.cardImage &&
                            React.createElement("div", { className: "card-header" },
                                React.createElement("img", { src: item.fields.cardImage, width: "460", height: "160", title: item.fields.cardImage_title, alt: item.fields.cardImage_description ? item.fields.cardImage_description : "", className: "img-fluid card-img", itemProp: "image" }),
                                ImageSchema(item.fields.cardImage, item.fields.title)),
                        item.fields.title &&
                            React.createElement("div", { className: "card-body px-4" },
                                React.createElement("div", { className: "h3", title: item.fields.title, itemProp: "headline" }, item.fields.title)),
                        React.createElement("div", { className: "card-footer px-4" },
                            React.createElement("div", { className: "card-text flex-grow-1" },
                                React.createElement("span", { itemProp: "datePublished" }, formatDate),
                                React.createElement("span", null, "\u00A0\u2022\u00A0"),
                                React.createElement("span", { itemProp: "timeRequired" }, item.fields.timeToRead)),
                            React.createElement("div", { className: "card-button" },
                                React.createElement(Link, { "aria-label": "Read" + j, className: "btn btn-with-icon arrow arrow-right", to: item.url ? item.url : "#", role: "button", title: item.fields.title ? item.fields.title : "", itemProp: "url" }))),
                        React.createElement("meta", { itemProp: "author", content: "Sky Lagoon" })))));
        })),
        storyLength > amount &&
            React.createElement("div", { className: "row justify-content-center" },
                React.createElement("div", { className: "col my-4 col-auto" },
                    React.createElement("button", { "aria-label": "Show More Articles", className: "btn btn-show-more text-moss", onClick: incrementAmount }, "Show More Articles")))));
}
